import { CommonModule } from '@angular/common';
import { Component, signal, WritableSignal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';
import { ResendBtnComponent } from '../../../shared/components/resend-btn/resend-btn.component';
import { ProfileDropdownComponent } from '../../../shared/components/profile-dropdown/profile-dropdown.component';
import { VerifyPhoneComponent } from '../../onboarding/verify-phone/verify-phone.component';
import { VerifyService } from '../../../_services/verify-service/verify.service';
import { Observable } from 'rxjs';
import { DetailResponse } from '../../../_interfaces/verify-account';
import { GoToStep } from '../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../store/onboarding/onboarding.model';

@Component({
  selector: 'app-verify-email',
  imports: [NgOtpInputModule, FormsModule, CommonModule, ResendBtnComponent, ProfileDropdownComponent],
  templateUrl: '../../onboarding/verify-phone/verify-phone.component.html',
})
export class UpdateContactDetailsComponent extends VerifyPhoneComponent {
  readonly route = inject(ActivatedRoute);
  readonly verifyService = inject(VerifyService);

  protected override title: string[] = ['Enter code'];
  protected override subtitle: string = '';

  protected override resend$?: Observable<DetailResponse> = undefined;

  readonly identifier: WritableSignal<string> = signal<string>('');
  readonly token: WritableSignal<string> = signal<string>('');

  constructor() {
    super();

    this.store.dispatch(new GoToStep(OnboardingSteps.VERIFY_PHONE));
    this.progressBarService.setHideProgress(true);
    this.subscriptions.add(
      this.route.queryParams.subscribe((value) => {
        this.identifier.set(value['change_id']);
        this.token.set(value['token']);
        this.phone.set(value['phone']);
      }),
    );
  }

  override setup(): void {
    /* empty */
  }

  override requestOTP(): void {
    this.subscriptions.add(
      this.verifyService.validContactDetailsToken(this.identifier(), { token: this.token() }).subscribe({
        next: (data) => {
          if (data.valid) {
            this.subscriptions.add(this.verifyService.sendContactDetailsOTP(this.identifier()).subscribe());
          } else {
            this.toErrorPage();
          }
        },
        error: () => this.toErrorPage(),
      }),
    );
    const phone = this.route.snapshot.queryParams['phone'];
    this.phone.set(phone ? `+27 ** *** ${phone}` : '');
  }

  override verifyPhone(): void {
    this.subscriptions.add(
      this.verifyService
        .verifyContactDetails(this.identifier(), {
          otp: this.otpCode,
          token: this.token(),
        })
        .subscribe({
          next: () => this.toSuccessPage(),
          error: () => this.toErrorPage(),
        }),
    );
  }

  private toSuccessPage(): void {
    this.router.navigate(['success'], { relativeTo: this.route });
  }

  private toErrorPage(): void {
    this.router.navigate(['error'], { relativeTo: this.route });
  }
}
